import { render } from "./RightSide.vue?vue&type=template&id=cb064d5c"
import script from "./RightSide.vue?vue&type=script&lang=js"
export * from "./RightSide.vue?vue&type=script&lang=js"

import "./RightSide.vue?vue&type=style&index=0&id=cb064d5c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__